// Copyright 2025-2026 - Hewlett Packard Enterprise Company
import { useContext, useMemo } from 'react';
import { Grommet } from 'grommet';
import { hpe as v8 } from 'grommet-theme-hpe';
import { hpe as v7 } from 'theme-v7';

import useFlags from './hooks/useFlags';
import { ThemeModeContext } from './providers/ThemeModeProvider';

const versionMap = {
  7: v7,
  8: v8,
};

export default function ThemedApp({ children }) {
  const { themeMode } = useContext(ThemeModeContext);

  const flags = useFlags();
  const themeVersion = flags.T_20260429_69543_THEME_VERSION();
  const [theme, background] = useMemo(() => {
    const resolvedTheme = versionMap[themeVersion] ?? v7;
    const resolvedBackground = 'background-back';
    return [resolvedTheme, resolvedBackground];
  }, [themeVersion]);

  return (
    <Grommet theme={theme} themeMode={themeMode} background={background}>
      {children}
    </Grommet>
  );
}
